function initLoginPageTracking() {
    function handleLoginMethod() {
        const loginMethod = this.dataset.trackingLogin;
        sessionStorage.setItem('ga4_login_method', loginMethod)
    }

    function addLoginMethodHandlers() {
        const loginMethodButtons = document.querySelectorAll('[data-tracking-login]');
        loginMethodButtons.forEach(button => {
            button.addEventListener('click', handleLoginMethod)
        })
    }
    addLoginMethodHandlers();
}

initLoginPageTracking()